import { render, staticRenderFns } from "./SystemTemplateDetails.vue?vue&type=template&id=7385db1b&scoped=true&"
import script from "./SystemTemplateDetails.vue?vue&type=script&lang=ts&"
export * from "./SystemTemplateDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7385db1b",
  null
  
)

export default component.exports